
const $ = window.jQuery;

import plugin, {PluginBase} from '../utils/plugin'
import YouTubePlayer from 'youtube-player';
import VimeoPlayer from '@vimeo/player';

export default class PluginClass extends PluginBase {

  constructor(el, options) {
    super(el, options);

    this.isPaused = true;

    this.$iframe = this.$el.find('iframe');
    this.src = this.$iframe.attr('data-src');
    this.vendor = '';

    if( !this.src ) {
      this.$el.addClass('is-started');
      console.log('error initializing embedded player: no src found');
      return;
    }
    
    const observer = new IntersectionObserver(entries => {
      for(const entry of entries ) {
        if( entry.isIntersecting ) {
          this.init();
          observer.disconnect();
        }
      }
    });
    observer.observe(this.el);
    
  }

  init() {
    this.$iframe.attr('src', this.src);
    if( this.src.match(/youtube(-nocookie)?.com/gi) ) {
      this.initYouTube();
    } else if( this.src.match(/vimeo.com/gi) ) {
      this.initVimeo();
    }

    this.$el.find(this.options.playButtonSelector).click(e => {
      e.stopPropagation();
      e.preventDefault();
      this.play();
    })
  }

  initYouTube() {
    this.vendor = 'youtube';

    let player = this.player = YouTubePlayer(this.$iframe[0]);

    player.on('stateChange', event => {
      if( event.data === window.YT.PlayerState.BUFFERING ) {
        this.onVideoStarted();
      } else if( event.data === window.YT.PlayerState.ENDED ) {
        this.onVideoEnded();
      }
    });

    if( this.options.autoplay ) {
      player.playVideo().catch(error => {
        this.$el.removeClass('is-started');
      })
    }
  }

  initVimeo() {
    this.vendor = 'vimeo';

    let player = this.player = new VimeoPlayer(this.$iframe[0]);
    player.on('bufferstart', () => this.onVideoStarted());
    player.on('play', () => this.onVideoStarted());
    player.on('ended', () => this.onVideoEnded());

    if( this.options.autoplay ) {
      player.play().catch(error => {
        this.$el.removeClass('is-started');
      })
    }
  }

  play() {
    this.isPaused = false;
    switch( this.vendor ) {
      case 'youtube':
        this.player.playVideo();
        break;
      case 'vimeo':
        this.player.play().catch(e => this.log(e));
        break;
    }
  }

  pause() {
    this.isPaused = true;
    switch( this.vendor ) {
      case 'youtube':
        this.player.pauseVideo();
        break;
      case 'vimeo':
        this.player.pause().catch(e => this.log(e));
        break;
    }
  }

  reset() {
    switch( this.vendor ) {
      case 'youtube':
        this.player.seekTo(0);
        break;
      case 'vimeo':
        this.player.setCurrentTime(0).catch(e => this.log(e));
        break;
    }
    this.pause();
    this.$el.removeClass('is-started');
  }

  togglePlay() {
    if( this.isPaused ) {
      this.play();
    } else {
      this.pause();
    }
  }

  onVideoStarted() {
    this.$el.addClass('is-started');
    this.options.onStarted();
  }

  onVideoEnded() {
    this.$el.removeClass('is-started');
    this.options.onEnded();
  }

  log( msg ) {
    console.log( msg );
  }

  /**
   * Destroys the plugin
   */
  destroy() {
    super.destroy();
  }
}

/**
 * Defaults
 * @type {{color: string, status: number}}
 */
PluginClass.DEFAULTS = {
  autoplay: true,
  loop: true,
  onStarted: () => {},
  onEnded: () => {},
  playButtonSelector: '.video_play'
};

/**
 * make jQuery Plugin
 */
plugin('embeddedPlayer', PluginClass, true);
